<div *ngIf="!isLoggedIn" class="jobluu-social-login">
  <div id="googleLoginButton"></div>
</div>
